module.exports = __webpack_public_path__ + "img/montage-logo.89b5cb37.png";